module.exports = __webpack_public_path__ + "img/2.4a1008c4.png";